module.exports = __webpack_public_path__ + "img/big_11B04_orange.7f913950.png";